module.exports = __webpack_public_path__ + "static/media/BELT-BNB-BELT.c9436875.png";